export default function reportTime(startTime, endTime) {
    return `${startTime.format('h:mm A')} - ${endTime.format('h:mm A')}`;
}



/** WEBPACK FOOTER **
 ** ./app/src/utils/reportTime.js
 **/